
const GLOBAL_ENV = {
  VUE_APP_BASE_DOMAIN: 'http://192.168.10.1:6006',
  VUE_APP_PUBLIC_PATH: '/'
}

module.exports = GLOBAL_ENV
